<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        {{ actionModalView.includes('edit') ? "Editing" : "Create New" }} Dashboard User
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container user-form-container">
      <div class="ac-body-sub-container">
        <div class="ac-input-container">
          <div class="ac-input-header">
            First Name
          </div>
          <SACInput
            field="firstName"
            placeholder="Enter First Name"
            :value="firstName"
            :error="errorObjL.userFirstNameErr"
            :change="handleChange"
          />
        </div>
        <div class="ac-input-container">
          <div class="ac-input-header">
            Last Name
          </div>
          <SACInput
            field="lastName"
            placeholder="Enter Last Name"
            :value="lastName"
            :error="errorObjL.userLastNameErr"
            :change="handleChange"
          />
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Email
        </div>
        <SACInput
          field="email"
          placeholder="Enter Email"
          :value="email"
          :error="errorObjL.userEmailErr"
          :change="handleChange"
        />
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Role
        </div>
        <div class="ac-row-container">
          <SACDropdown
            class="margin-bottom"
            :options="[
              {
                label: 'Admin',
                value: 'Admin',
              }, {
                label: 'Manager',
                value: 'Manager',
              }, {
                label: 'Viewer',
                value: 'Viewer',
              },
            ]"
            :value="role"
            placeholder="Select Role"
            :error="errorObjL.roleErr"
            field="role"
            :change="handleChange"
          />
        </div>
      </div>
      <div
        v-if="isSmacAdmin"
        :key="errorObjL.techCorpErr"
        class="ac-input-container"
      >
        <div class="ac-input-header">
          Partner
        </div>
        <SACDropdown
          class="margin-bottom"
          :options="allBranches(true)"
          :value="corporationId"
          placeholder="Select Partner"
          :showSearch="true"
          :error="errorObjL.techCorpErr"
          field="corporationId"
          :change="handleChange"
        />
      </div>
      <div
        v-if="currentAdmin.parentCorp"
        :key="errorObjL.techCorpErr"
        class="ac-input-container"
      >
        <div class="ac-input-header">
          Branch
        </div>
        <SACDropdown
          class="margin-bottom"
          :options="allBranches(false)"
          :value="corporationId"
          :error="errorObjL.techCorpErr"
          placeholder="Select Branch"
          field="corporationId"
          :change="handleChange"
        />
      </div>
      <div class="error-message">
        {{ errorObj.createErr }}
      </div>
    </div>
    <div class="ac-footer-container just-between">
      <div class="flex-row">
        <button
          v-if="actionModalView === 'edit-user'
            && currentUser.accountStatus === 'Active'"
          type="button"
          class="new-del-btn"
          @click="handleSave('Deactivated')"
        >
          Deactivate
        </button>
        <button
          v-if="actionModalView === 'edit-user'
            && currentUser.accountStatus !== 'Active'"
          type="button"
          class="new-fill-btn"
          @click="handleSave('Active')"
        >
          Reactivate
        </button>
      </div>
      <div class="flex-row">
        <button
          v-if="actionModalView === 'edit-user'"
          type="button"
          class="new-icn-btn"
          @click="toggleActionModal(true, 'change-password')"
        >
          Change Password
        </button>
        <button
          type="button"
          class="new-fill-btn"
          @click="handleSave(null)"
        >
          Save
        </button>
      </div>
    </div>
    <ProcessOverlay
      :show="saving"
      text="Saving"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import settingMixin from '@shared/mixins/settingMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

import emailValidation from '@shared/lib/errorCatch/emailValidation';

export default {
  name: 'PlatformUserForm',
  components: {
    SACInput,
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [settingMixin],
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      role: '',
      corporationId: '',
      errorObjL: {},
      saving: false,
    };
  },
  mounted() {
    if (this.currentUser.id) {
      const {
        firstName,
        lastName,
        email,
        role,
        corporationId,
      } = this.currentUser;
      this.firstName = firstName;
      this.lastName = lastName;
      this.email = email;
      this.role = role;
      this.corporationId = corporationId;
    }
  },
  methods: {
    handleChange(field, value) {
      this[field] = value;
    },
    async handleSave(updateStatus) {
      const {
        id,
        email,
        accountStatus,
      } = this.currentUser;
      const error = {};
      if (!this.firstName) {
        error.userFirstNameErr = 'Please enter a first name';
      }
      if (!this.lastName) {
        error.userLastNameErr = 'Please enter a last name';
      }
      if (!this.email) {
        error.userEmailErr = 'Please enter an email';
      } else if (!emailValidation(this.email)) {
        error.userEmailErr = 'Please enter a valid email';
      }
      if (!this.role) {
        error.roleErr = 'Please select a role';
      }
      if ((this.currentAdmin.parentCorp || this.isSmacAdmin) && this.corporationId === '') {
        error.techCorpErr = `Please select a ${this.currentAdmin.parentCorp ? 'branch' : 'partner'}`;
      }
      if (!updateStatus) {
        updateStatus = accountStatus;
      }
      this.errorObjL = error;
      if (Object.keys(error).length === 0) {
        const newAdmin = {
          id,
          firstName: this.firstName,
          lastName: this.lastName,
          role: this.role,
          corporationId: this.corporationId,
          accountStatus: updateStatus,
        };
        if (this.email !== email) {
          newAdmin.email = this.email;
        }
        try {
          this.saving = true;
          const success = await this.$store.dispatch('createUser', newAdmin);
          if (success) {
            let message = `Successfully created dashboard user ${this.firstName}`;
            if (this.actionModalView.includes('edit')) {
              message = `Successfully updated dashboard user ${this.firstName}`;
            }
            this.$store.dispatch('showSuccessToast', {
              message,
            });
          }
        } catch (err) {
          if (err.message === 'Email already exists') {
            this.errorObjL.userEmailErr = 'User already exists. Please use different email address.';
          } else {
            this.$store.dispatch('showAlertToast', {
              message: 'There was an unexpected error. Please try again or contact support',
            });
          }
        }
        this.saving = false;
      }
    },
  },
};
</script>
